import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { useGtmPageView } from '../hooks/use-gtm-page-view.hook';
import { LocationSeo } from './location-seo';

export const MarketingRootLayout: FC = () => {
  useGtmPageView();

  return (
    <>
      <LocationSeo />
      <Outlet />
    </>
  );
};

MarketingRootLayout.displayName = 'MarketingRootLayout';
